export enum SizesButton {
  XS = 'xs',
  S = 's',
  SM = 'sm',
  M = 'm',
  MD = 'md',
}
